/* In this file, either `index.ext.ts` or `index.sdk.ts` is imported based on build type. */

// @ts-ignore
import contentScript from './index.BUILD_MODE'

contentScript()
